import React, { memo } from 'react'
import { Stack } from '@mui/material'

import qbxBanner from '../../assets/images/qbx.png'

const QBXBanner = ({ children }) => {
  return (
    <Stack sx={{ alignItems: 'center', justifyContent: 'center' }}>
      <img src={qbxBanner} style={{ height: 300 }} />
      {children}
    </Stack>
  )
}

export default memo(QBXBanner)
